<template>
  <div class="container-fluid">
    <div class="spinner-cover" v-if="is_loading">
      <div class="spinner"></div>
    </div>
    <!-- NAV ON Bautagebuch TODO: FIX ALIGNMENT -->
    <div class="button-areas">
      <div class="row border-bottom pt-2 pb-2">
        <div :class="$route.name === 'editConstructionReport' ? 'col-xl-6 col-lg-6 col-md-6' : 'col-lg-4 col-md-4'"  class="col-xl-3 col-3 pl-md-0 pl-lg-1 text-left pr-0">
          <button  type="button" v-if="isSideBarActive" @click="$store.commit('toggleFilterTab',false)" class="btn btn-light filter-btn filter-icon-sidebar ml-1" style="background: dodgerblue;color: white !important;">
            <img class="plus-img" src="@/assets/images/img-icons/filter2_white.svg" alt="img">
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
          <span class="icons-text-top-bar"> Filter</span>
          </button>
          <button type="button" v-else @click="$store.commit('toggleFilterTab',true)" :class="{'visibility-hidden': $route.name === 'editConstructionReport'}"  class="btn btn-light filter-btn filter-icon-sidebar ml-1">
            <img class="plus-img"  src="@/assets/images/img-icons/filter2_black.svg" alt="img" >
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
           <span class="icons-text-top-bar"> Filter</span>
          </button>
          <button type="button" class="btn btn-light ml-1" @click="$router.push({ name: 'photoDocumentation' })">
            {{$t('documentation')}}
          </button>
          <button type="button" class="btn btn-light active simple-photo-check ml-1">
            {{$t('construction_diaries')}}
          </button>
        </div>

        <div class="col photo-top-midle" v-show="$route.name !== 'editConstructionReport'">
          <!--          <div class="w-100" v-if="$route.name !== 'photoDocumentEdit' && $route.name !== 'photoDocumentCreate'">-->
          <div id="datepicker_f" class="d-flex input-group this-calender input-group-sm date mr-2 ml-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <div class="input-group-prepend">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
            <input id="from" type="text" class="form-control date-input" data-date-format="dd.mm.yyyy" v-model="dateRangeFrom" readonly="">
          </div>

          <div class="filter level-filter level-req">
            <input type="text" id="rangeSliderInConstructionDocs" class="js-range-slider" name="my_range" value="" />
          </div>

          <div id="datepicker_t" class="d-flex input-group this-calender input-group-sm date ml-2 mr-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <input id="to"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   v-model="dateRangeTo"
                   readonly="" style="margin-top: 0">
            <div class="input-group-append">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
          </div>
          <!--            </div>-->
        </div>
        <!--         Date Range Slider Ends Here-->

        <div :class="{'col-xl-6 col-lg-6 col-md-6' : $route.name === 'editConstructionReport'}" class="right-btn col-2 text-right d-none d-sm-block pl-0 pr-md-0 pr-1 pb-0">
          <button :class="{'visibility-hidden': (!report_id || $route.name === 'createConstructionReport'), active : $route.name === 'editConstructionReport'}" @click="editConstructionReport"  type="button" class="btn btn-light mr-1" :disabled="!usercan('editor')">
            <i class="fa-regular fa-pen-to-square font14" style="font-size: 0.8rem"></i>
            <span class="icons-text-top-bar"> {{$t("edit")}} </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  props: ['range'],
  name: 'TopBar',
  data () {
    return {
      searchString: '',
    }
  },
  mounted () {
    this.setDatePickers();
  },
  computed: {
    ...mapState({
      isSideBarActive: state => state.constructionDiary.filterTab,
      isDetailsActive: state => state.constructionDiary.activeOverView,
      is_loading: state => state.constructionDiary.is_loading,
      meta: state => state.constructionDiary.reportsMeta,
    }),

    //set date range for label on step change to avoid extra api requests
    dateRangeFrom: {
      get () {
        return  this.$store.state.constructionDiary.maxMetaDate
      },
      set(val){
        this.$store.commit('setConstructionMetaDateFrom',val)
      }
    },
    dateRangeTo: {
      get () {
        return  this.$store.state.constructionDiary.minMetaDate
      },
      set(val){
        this.$store.commit('setConstructionMetaDateTo', val)
      }
    },


    report_id(){
     return  this.$store.state.constructionDiary.selectedReport.constructionreportid || this.$route.params.reportId || 0;
    },

    //date range for the filter data by api on slider finish slide
    dateTo: {
      get () {
        return this.$store.state.photoDocumentation.dateRangeTo
      },
      set (val) {
        this.$store.commit('setDateRangeTo', val)
      }
    },
    dateFrom: {
      get () {
        return this.$store.state.photoDocumentation.dateRangeFrom
      },
      set (val) {
        this.$store.commit('setDateRangeFrom', val)
      }
    }
  },
  methods: {
    editConstructionReport(){
      if (this.$route.name !== "editConstructionReport"){
        this.$router.push({name: 'editConstructionReport',params:{id: this.$route.params.id,reportId: this.report_id }})
      }else {
        this.$router.push({name: 'ConstructionReportPreview',params:{id: this.$route.params.id,reportId: this.report_id }})
      }
    },

    async setDatePickers () {

      await this.setDateRangeSlider();

      let my_range = $("#rangeSliderInConstructionDocs").data("ionRangeSlider");
      let _this = this
      // $('.datepicker').datepicker({
      $('#to, #from').datepicker({
        autoclose: true,
        todayHighlight: true
      }).change(function (event){
        let value = event.target.value;
        let from =  moment(_this.meta.minimumDate,'DD.MM.YYYY');
        if (event.target.getAttribute('id') === 'from'){
          let dif_from = moment(value , 'DD.MM.YYYY');
          let dif = moment.duration(dif_from.diff(from)).asDays();
          my_range.update({
            from: Math.floor(dif),
          });
        } else {
          let to =  moment(_this.meta.maximumDate,'DD.MM.YYYY');
          let dif_to = moment(value , 'DD.MM.YYYY');
          let difToDate = moment.duration(dif_to.diff(to)).asDays();
          my_range.update({
            to: Math.floor(_this.range[1] + difToDate),
          });
        }

        let d_from = $('#from').val();
        let d_to = $('#to').val();
        _this.dateFrom = d_from;
        _this.dateTo  = d_to;
        _this.dateRangeFrom = d_from;
        _this.dateRangeTo  = d_to;
      });
    },

    setDateRangeSlider(){
      let _this = this
      if (_this.range){
        $(".js-range-slider").ionRangeSlider({
          type: "double",
          min: _this.range[0],
          max: _this.range[1],
          drag_interval: true,
          hide_min_max: true,
          hide_from_to: true,
          onFinish: function (val){
            _this.setDateRanges(val);
            _this.onSliderChangeStep(val);
          },
          onChange: function (val){
            _this.onSliderChangeStep(val);
          }
        });
      }
    },

    setDateRanges (val) {
      let from = val.from
      let to = val.to
      this.dateFrom = moment(this.meta.minimumDate,'DD.MM.YYYY').add(from,'day').format('DD.MM.YYYY');
      this.dateTo = moment(this.meta.maximumDate,'DD.MM.YYYY').add(to  - this.range[1], 'day').format('DD.MM.YYYY')
    },

    onSliderChangeStep(val){
      let from = val.from;
      let to = val.to;
      this.dateRangeFrom = moment(this.meta.minimumDate,'DD.MM.YYYY').add(from,'day').format('DD.MM.YYYY');
      this.dateRangeTo = moment(this.meta.maximumDate,'DD.MM.YYYY').add(to  - this.range[1], 'day').format('DD.MM.YYYY')
    },


    toggleSideBar (value) {
      this.$store.commit('toggleFilterTab', value)
      this.$store.commit('toggleOverViewTab', false)
    },

    toggleDetails () {
      let flag = !this.isDetailsActive
      this.$store.commit('toggleOverViewTab', flag)
      this.$store.commit('toggleFilterTab', false)
    },

    showOverview () {
      this.$store.commit('toggleOverViewTab', false)
    }
  },
}
</script>
<style scoped type="text/css">
.active{
  color: white !important;
  background: dodgerblue !important;
}
.slider-horizontal{
  padding: 7px 4px !important;
}
.visibility-hidden{
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/ConstructionDiaryTopBar.vue